import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => {
  const sideBarBackgroundColor = () => {
    if (import.meta.env.VITE_ENV === "production") {
      return theme.palette.primary.main
    } else {
      return "#5A1483"
    }
  }
  return {
    sideBar: {
      flexGrow: 1,
      display: "flex",
      flexDirection: "column",
      backgroundColor: sideBarBackgroundColor(),
      color: "#fff",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
        display: "none",
        height: "60px",
      },
    },
    divider: {
      backgroundColor: "#f5f5f5",
      height: 2,
      width: "100%",
    },
    phoneViewSideBar: {
      [theme.breakpoints.up("sm")]: {
        display: "none",
        height: "20px",
      },
      [theme.breakpoints.down("sm")]: {
        display: "flex",
        height: "60px",
        minWidth: "100%",
        backgroundColor: sideBarBackgroundColor(),
      },
    },
    logo: {
      height: "90%",
      width: "90%",
      zIndex: 1,
    },
    tab: {
      "&:hover": {
        display: "flex",
        justifyContent: "center",
        backgroundColor: "rgb(23, 165, 177, 0.2)",
        width: "100%",
      },
    },
    highlight: {
      display: "flex",
      justifyContent: "center",
      backgroundColor: "rgb(23, 165, 177, 0.2)",
      width: "100%",
    },
    link: {
      "&:focus, &:hover, &:visited, &:link, &:active": {
        textDecoration: "none",
        color: "inherit",
        outline: "none",
      },
    },
    menu: {
      width: "200px",
    },
  }
})

export default styles
